"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.InfoBox = exports.Session = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("@material-ui/core/styles");

var _Divider = _interopRequireDefault(require("@material-ui/core/Divider"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _ButtonBase = _interopRequireDefault(require("@material-ui/core/ButtonBase"));

var _Chip = _interopRequireDefault(require("@material-ui/core/Chip"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faMapMarkerAlt = require("@fortawesome/free-solid-svg-icons/faMapMarkerAlt");

var _faCalendarCheck = require("@fortawesome/free-solid-svg-icons/faCalendarCheck");

var _faCalendarPlus = require("@fortawesome/free-solid-svg-icons/faCalendarPlus");

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DEFAULT_BUTTON_COLOR = '#2697FF';
var useStyles = (0, _styles.makeStyles)({
  root: {
    height: 'inherit',
    width: 'inherit',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    backgroundColor: '#fff',
    position: 'relative',
    border: '1px solid #e0e0e0',
    borderRadius: '4px'
  },
  header: {
    marginTop: '24px',
    marginLeft: '18px',
    marginBottom: '13px',
    fontWeight: '500',
    fontSize: '20px',
    lineHeight: '24px'
  },
  content: {
    height: 'calc(100% - 131px)',
    overflow: 'hidden'
  },
  footer: {
    flexGrow: 1,
    textAlign: 'center',
    width: '100%',
    position: 'absolute',
    bottom: '0',
    height: '68px'
  },
  footerContainer: {
    position: 'relative',
    top: '50%'
  }
}, {
  name: 'Mui-WidgetAgenda'
});
var useStylesInfoBox = (0, _styles.makeStyles)({
  root: {
    position: 'relative',
    top: 'calc((100% + 94px)/2)',
    // Considers the footer height to vertically align in center
    transform: 'translateY(-50%)',
    textAlign: 'center'
  },
  footerText: {
    marginBottom: '34px',
    fontWeight: '500',
    fontSize: '18px',
    lineHeight: '22px'
  }
}, {
  name: 'Mui-WidgetInfoBox'
});
var useStylesSession = (0, _styles.makeStyles)(theme => ({
  root: {
    padding: '24px 18px',
    minHeight: '144px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'inherit',
    '& > :first-child': {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'flex-start',
      flexGrow: 1
    }
  },
  button: {
    overflow: 'hidden'
  },
  header: {
    fontSize: '18px',
    lineHeight: '22px',
    fontWeight: '500',
    [theme.breakpoints.down('md')]: {
      // Display ellipsis after 3 lines
      overflow: 'hidden',
      display: '-webkit-box',
      '-webkit-box-orient': 'vertical',
      '-webkit-line-clamp': 3
    }
  },
  text: {
    fontSize: '14px',
    lineHeight: '17px',
    margin: '4px 0',
    maxWidth: '97%',
    // Display ellipsis after 2 lines
    overflow: 'hidden',
    display: '-webkit-box',
    '-webkit-box-orient': 'vertical',
    '-webkit-line-clamp': 2
  },
  iconLocation: {
    marginRight: '3px'
  },
  iconScheduled: {
    margin: '0 auto',
    padding: '0 12px',
    '&&': {
      width: 'inherit'
    }
  },
  chipContainer: {
    overflow: 'hidden',
    '&.session': {
      marginBlock: '6px'
    }
  },
  sessionChip: {
    color: theme.palette.text.primary,
    margin: '3px 6px 3px 0',
    paddingInline: '4px',
    maxHeight: '24px'
  },
  trackChip: {
    fontSize: '13px',
    maxHeight: '22px',
    margin: '3px 6px 3px 0',
    paddingInline: '8px',
    maxWidth: '300px',
    borderRadius: 4
  }
}), {
  name: 'Mui-WidgetAgendaSession'
});
var Session = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  var {
    title,
    sessionRoles,
    startDate,
    startTime,
    endDate,
    endTime,
    location,
    tracks,
    url,
    onClick,
    onSchedule,
    scheduled,
    addTooltipTitle = '',
    removeTooltipTitle = '',
    color = DEFAULT_BUTTON_COLOR
  } = _ref;
  var classes = useStylesSession();

  var handleOnSchedule = e => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    if (onSchedule) {
      onSchedule(!scheduled);
    }
  };

  var isSameDate = !startDate || !endDate || startDate === endDate;
  return /*#__PURE__*/_react.default.createElement(_core.ListItem, {
    ref: ref,
    className: classes.root,
    component: "div"
  }, /*#__PURE__*/_react.default.createElement(_ButtonBase.default, {
    onClick: onClick,
    href: url,
    component: "a"
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "h3",
    className: classes.header
  }, title), sessionRoles && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(classes.chipContainer, 'session')
  }, sessionRoles.map(sessionRole => /*#__PURE__*/_react.default.createElement(_Chip.default, {
    key: "".concat(sessionRole.name, "-session-chip"),
    className: classes.sessionChip,
    label: sessionRole.name
  }))), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: classes.text
  }, isSameDate && !startDate && /*#__PURE__*/_react.default.createElement("span", null, startTime, " - ", endTime), isSameDate && startDate && /*#__PURE__*/_react.default.createElement("span", null, startDate, " ", /*#__PURE__*/_react.default.createElement("br", null), startTime, " - ", endTime), !isSameDate && /*#__PURE__*/_react.default.createElement("span", null, startDate, ", ", startTime, " - ", /*#__PURE__*/_react.default.createElement("br", null), endDate, ", ", endTime)), location && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: classes.text
  }, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faMapMarkerAlt.faMapMarkerAlt,
    className: classes.iconLocation
  }), " ", location), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(classes.chipContainer, 'track')
  }, tracks.map(track => /*#__PURE__*/_react.default.createElement(_Chip.default, {
    key: "".concat(track.name, "-track-chip"),
    className: classes.trackChip,
    label: track.name,
    style: {
      color: "".concat(track.color),
      borderColor: "".concat(track.color),
      backgroundColor: (0, _styles.fade)("".concat(track.color), 0.15)
    }
  })))), scheduled === false && /*#__PURE__*/_react.default.createElement(_ButtonBase.default, {
    onClick: handleOnSchedule
  }, /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
    title: addTooltipTitle,
    placement: "top",
    arrow: true,
    PopperProps: {
      style: {
        display: addTooltipTitle ? 'block' : 'none'
      }
    }
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faCalendarPlus.faCalendarPlus,
    className: classes.iconScheduled,
    size: "lg"
  })))), scheduled === true && /*#__PURE__*/_react.default.createElement(_ButtonBase.default, {
    onClick: handleOnSchedule
  }, /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
    title: removeTooltipTitle,
    placement: "top",
    arrow: true,
    PopperProps: {
      style: {
        display: removeTooltipTitle ? 'block' : 'none'
      }
    }
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faCalendarCheck.faCalendarCheck,
    className: classes.iconScheduled,
    size: "lg",
    color: color
  })))));
});
exports.Session = Session;
Session.propTypes = {
  /**
   * The title of the session
   */
  title: _propTypes.default.string.isRequired,

  /**
   * The title of the Add to your Agenda button tooltip
   */
  addTooltipTitle: _propTypes.default.string,

  /**
   * The title of the Remove from your Agenda button tooltip
   */
  removeTooltipTitle: _propTypes.default.string,

  /**
   * The user's assigned session roles, if any
   */
  sessionRoles: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string
  })),

  /**
   * The start date, displays it without any change
   */
  startDate: _propTypes.default.string,

  /**
   * The start time, displays it without any change
   */
  startTime: _propTypes.default.string.isRequired,

  /**
   * The end date, displays it without any change
   */
  endDate: _propTypes.default.string,

  /**
   * The end time, displays it without any change
   */
  endTime: _propTypes.default.string.isRequired,

  /**
   * The location for the session
   */
  location: _propTypes.default.string,

  /**
   * Array of tracks with a session, needs to have name and color
   */
  tracks: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string,
    color: _propTypes.default.string
  })),

  /**
   * To go to a particular session url, passed as href to listItem
   */
  url: _propTypes.default.string,

  /**
   * Callback for onClick
   */
  onClick: _propTypes.default.func,

  /**
   * Callback for onSchedule
   */
  onSchedule: _propTypes.default.func,

  /**
   * Scheduled status of session
   */
  scheduled: _propTypes.default.bool,

  /**
   * Color of scheduled icons
   */
  color: _propTypes.default.string
};

var InfoBox = (_ref2) => {
  var {
    onClick,
    text,
    buttonText,
    url,
    color = DEFAULT_BUTTON_COLOR
  } = _ref2;
  var classes = useStylesInfoBox();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, text && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.footerText
  }, text), onClick && /*#__PURE__*/_react.default.createElement(_Button.default, {
    component: "a",
    href: url,
    variant: "outlined",
    color: "primary",
    onClick: onClick,
    style: {
      borderColor: color,
      color
    }
  }, buttonText));
};

exports.InfoBox = InfoBox;
InfoBox.propTypes = {
  /**
   * The action abutton on Click
   */
  onClick: _propTypes.default.func,

  /**
   * The url for href on click on button
   */
  url: _propTypes.default.string,

  /**
   * The info text
   */
  text: _propTypes.default.node,

  /**
   * The button text
   */
  buttonText: _propTypes.default.string,

  /**
   * color for the button
   */
  color: _propTypes.default.string
};

var Agenda = (_ref3) => {
  var {
    children,
    title,
    footer: Footer,
    footerProps
  } = _ref3;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: classes.header
  }, title), /*#__PURE__*/_react.default.createElement(_Divider.default, null), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.content
  }, children, Footer && footerProps.onClick && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.footer
  }, /*#__PURE__*/_react.default.createElement(_Divider.default, null), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.footerContainer
  }, /*#__PURE__*/_react.default.createElement(Footer, footerProps)))));
};

Agenda.propTypes = {
  /**
   * Agenda container prop:  The user component or section component as children with data
   */
  children: _propTypes.default.arrayOf(_propTypes.default.node),

  /**
   * Agenda container prop: The title of the Agenda container
   */
  title: _propTypes.default.string.isRequired,

  /**
   * Agenda container prop: Footer for User Agenda widget
   */
  footer: _propTypes.default.func,

  /**
   * Agenda container prop: FooterProps for User Agenda widget Footer
   */
  footerProps: _propTypes.default.shape({
    onClick: _propTypes.default.func,
    url: _propTypes.default.string,
    text: _propTypes.default.node,
    buttonText: _propTypes.default.string,
    color: _propTypes.default.string
  })
};
var _default = Agenda;
exports.default = _default;